import gsap from "gsap";

const animateWorkLife = () =>{
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if(document.querySelector('.kirinus-balance-text-holder')){
        // if IntersectionObserver not supported
        if (!('IntersectionObserver' in window) ||
            !('IntersectionObserverEntry' in window) ||
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
            const left = entry.target.querySelector('.kirinus-balance-text-left');
            const right = entry.target.querySelector('.kirinus-balance-text-right');
            let a = '-20.0205vw';
            let b = '20.02005vw';
            let c = '20.02005vw';
            let d = '-20.02000005vw';
            if(vw < 1300){

                b = '15.02000005vw';
                d = '-15.02000005vw';
            }

            if(vw > 2560){

                b = '500px';
                d = '-500px';
            }
            let tl = gsap.timeline({
            });

            tl.addLabel('start')
            tl.fromTo(left, {x: a, opacity: 0}, {x: b, opacity: 1, duration: 1}, )
            tl.fromTo(right, {x: c, opacity: 0}, {x: d, opacity: 1, duration: 1}, ">-1")
            tl.addLabel('end')
        }else{
            let options = {

                threshold: 1.0
            }
            let callback = (entries, observer) => {
                entries.forEach(entry => {
                    const left = entry.target.querySelector('.kirinus-balance-text-left');
                    const right = entry.target.querySelector('.kirinus-balance-text-right');
                    let a = '-20.0205vw';
                    let b = '20.02005vw';
                    let c = '20.02005vw';
                    let d = '-20.02000005vw';
                    if(vw < 1300){

                        b = '15.02000005vw';
                        d = '-15.02000005vw';
                    }
                    if(vw > 2560){

                        b = '500px';
                        d = '-500px';
                    }
                    let tl = gsap.timeline({

                    });
                    tl.pause();
                    tl.addLabel('start')
                    if(!isFirefox){
                        tl.fromTo(left, {x: a, opacity: 0}, {x: b, opacity: 1, duration: 1}, )
                        tl.fromTo(right, {x: c, opacity: 0}, {x: d, opacity: 1, duration: 1}, ">-1")
                    } else{
                        tl.fromTo(left, {marginLeft: a, opacity: 0}, {marginLeft: b, opacity: 1, duration: 1}, )
                        tl.fromTo(right, {marginRight: -c, opacity: 0}, {marginRight: b, opacity: 1, duration: 1}, ">-1")
                    }

                    tl.addLabel('end')
                    if(entry.isIntersecting){
                        tl.play();
                    }

                });
            };
            let observer = new IntersectionObserver(callback, options);

            const holders = document.querySelectorAll('.kirinus-balance-text-holder');
            if(holders.length > 0){
                holders.forEach(holder => {
                    observer.observe(holder);

                })
            }
        }





    }
}
export default animateWorkLife;